import {
    GET_LIST_SKILLS, IS_LOADING_GET_LIST_SKILLS, DELETE_SKILL, GET_SKILL,ADD_SKILL,EDIT_SKILL, IS_LOADING_GET_LIST_MARK_TYPE, GET_LIST_MARK_TYPE, DELETE_MARK_TYPE,
    GET_MARK_TYPE, IS_LOADING_GET_LIST_CHAT_CATEGORIES, GET_LIST_CHAT_CATEGORIES, DELETE_CHAT_CATEGORY, GET_CHAT_CATEGORY, IS_LOADING_GET_LIST_COMMUNITY_CATEGORIES,
    GET_LIST_COMMUNITY_CATEGORIES, GET_COMMUNITY_CATEGORY,CREATE_COMMUNITY_CATEGORIE,EDIT_COMMUNITY_CATEGORIE, DELETE_COMMUNITY_CATEGORY,ADD_MARK_TYPE,EDIT_MARK_TYPE,ADD_CLASSIFIED_CATEGORIE,EDIT_CLASSIFIED_CATEGORY,IS_LOADING_GET_LIST_CLASSIFIED_CATEGORIES,
    GET_LIST_CLASSIFIED_CATEGORIES,GET_CLASSIFIED_CATEGORY,DELETE_CLASSIFIED_CATEGORY,IS_LOADING_GET_LIST_CLASSIFIED_SUBCATEGORIES,ADD_CLASSIFIED_SUBCATEGORIE,GET_LIST_CLASSIFIED_SUBCATEGORIES,
    GET_CLASSIFIED_SUBCATEGORY,EDIT_CLASSIFIED_SUBCATEGORY,DELETE_CLASSIFIED_SUBCATEGORY,IS_LOADING_GET_LIST_CLASSIFIED_STATUS,ADD_CLASSIFIED_STATUS,EDIT_CHAT_CATEGORIE,
    GET_LIST_CLASSIFIED_STATUS,EDIT_CLASSIFIED_STATUS,DELETE_CLASSIFIED_STATUS,GET_CLASSIFIED_STATUS,CREATE_CHAT_CATEGORIE,GET_PROFESSIONAL_COMMUNITY_CATEGORY,DELETE_PROFESSIONAL_COMMUNITY_CATEGORY,IS_LOADING_GET_LIST_PROFESSIONAL_COMMUNITY_CATEGORIES,CREATE_PROFESSIONAL_COMMUNITY_CATEGORIE,
    EDIT_PROFESSIONAL_COMMUNITY_CATEGORIE,GET_LIST_PROFESSIONAL_COMMUNITY_CATEGORIES
} from '../actions/types'

const initialState = {
    listSkills: [],
    isLoadingListSkills: false,
    skillInfo: {},
    isLoadingListMarkTypes: false,
    listMarkTypes: [],
    markType: {},
    isLoadingListChatCategories: false,
    listChatCategories: [],
    chatCategoryInfo: {},
    isLoadingListCommunityCategories: false,
    listOfCommunitiesCategory: [],
    communityCategoryInfo: {},
    isLoadingListClassifiedCategories:false,
    listClassifiedCategories:[],
    classifiedCategory:{},
    isLoadingListClassifiedSubcategories:false,
    listClassifiedSubcategories:[],
    classifiedSubcategory:{},
    listClassifiedStatus:[],
    isLoadingListClassifiedStatus:false,
    classifiedStatus:{},
    isLoadingListProfessionalCommunityCategories:false,
    listOfProfessionalCommunitiesCategory:[]



}

export default function (state = initialState, action) {
    switch (action.type) {

        case GET_LIST_SKILLS:
            return { ...state, listSkills: action.payload, isLoadingListSkills: false }
        case IS_LOADING_GET_LIST_SKILLS:
            return { ...state, isLoadingListSkills: true }
        case ADD_SKILL:
            var addSkill = state.listSkills
            addSkill.push(action.payload)
            return { ...state, listSkills: addSkill, isLoadingListSkills: false }
        case EDIT_SKILL:
            var editSkill = state.listSkills
            editSkill[action.payload.index] = action.payload.data
            return { ...state, listSkills: editSkill, isLoadingListSkills: false }
        case DELETE_SKILL:
        var deleteSkill = state.listSkills
        deleteSkill.splice(action.payload, 1)
        return { ...state, isLoadingListSkills: false, listSkills: deleteSkill }
        case GET_SKILL:
            return { ...state, skillInfo: action.payload }


        case ADD_MARK_TYPE:
            var addMarType = state.listMarkTypes
            addMarType.push(action.payload)
            return { ...state, listMarkTypes: addMarType, isLoadingListMarkTypes: false }
        case EDIT_MARK_TYPE:
            var editMarType = state.listMarkTypes
            editMarType[action.payload.index] = action.payload.data
            return { ...state, listMarkTypes: editMarType, isLoadingListMarkTypes: false }
        case IS_LOADING_GET_LIST_MARK_TYPE:
            return { ...state, isLoadingListMarkTypes: true }
        case GET_LIST_MARK_TYPE:
            return { ...state, listMarkTypes: action.payload, isLoadingListMarkTypes: false }
        case DELETE_MARK_TYPE:
            var deleteMarkType = state.listMarkTypes
            deleteMarkType.splice(action.payload, 1)
            return { ...state, isLoadingListMarkTypes: false, listMarkTypes: deleteMarkType }
        case GET_MARK_TYPE:
            return { ...state, markType: action.payload }


        case ADD_CLASSIFIED_CATEGORIE:
            var addClassifiedCategory = state.listClassifiedCategories
            addClassifiedCategory.push(action.payload)
            return { ...state, listClassifiedCategories: addClassifiedCategory, isLoadingListClassifiedCategories: false }
        case EDIT_CLASSIFIED_CATEGORY:
            var editClassifiedCategory = state.listClassifiedCategories
            editClassifiedCategory[action.payload.index] = action.payload.data
            return { ...state, listClassifiedCategories: editClassifiedCategory, isLoadingListClassifiedCategories: false }     
        case IS_LOADING_GET_LIST_CLASSIFIED_CATEGORIES:
            return { ...state, isLoadingListClassifiedCategories: true }
        case GET_LIST_CLASSIFIED_CATEGORIES:
            return { ...state, listClassifiedCategories: action.payload, isLoadingListClassifiedCategories: false }
        case DELETE_CLASSIFIED_CATEGORY:
            var deleteClassifiedCategory = state.listClassifiedCategories
            deleteClassifiedCategory.splice(action.payload, 1)
            return { ...state, isLoadingListClassifiedCategories: false, listClassifiedCategories: deleteClassifiedCategory }
        case GET_CLASSIFIED_CATEGORY:
            return { ...state, classifiedCategory: action.payload }



        case ADD_CLASSIFIED_SUBCATEGORIE:
            console.log()
            var addClassifiedSubcategory = state.listClassifiedSubcategories
            addClassifiedSubcategory.push(action.payload)
            return { ...state, listClassifiedSubcategories: addClassifiedSubcategory, isLoadingListClassifiedSubcategories: false }
        case EDIT_CLASSIFIED_SUBCATEGORY:
            var editClassifiedSubcategory = state.listClassifiedSubcategories
            editClassifiedSubcategory[action.payload.index] = action.payload.data
            return { ...state, listClassifiedSubcategories: editClassifiedSubcategory, isLoadingListClassifiedSubcategories: false }
        case IS_LOADING_GET_LIST_CLASSIFIED_SUBCATEGORIES:
            return { ...state, isLoadingListClassifiedSubcategories: true }
        case GET_LIST_CLASSIFIED_SUBCATEGORIES:
            return { ...state, listClassifiedSubcategories: action.payload || [], isLoadingListClassifiedSubcategories: false }
        case DELETE_CLASSIFIED_SUBCATEGORY:
            var deleteClassifiedSubCategory = state.listClassifiedSubcategories
            deleteClassifiedSubCategory.splice(action.payload, 1)
            return { ...state, isLoadingListClassifiedSubcategories: false, listClassifiedSubcategories: deleteClassifiedSubCategory }
        case GET_CLASSIFIED_SUBCATEGORY:
            return { ...state, classifiedSubcategory: action.payload }



        
        case ADD_CLASSIFIED_STATUS:
            var addClassifiedStatus = state.listClassifiedStatus
            addClassifiedStatus.push(action.payload)
            return { ...state, listClassifiedStatus: addClassifiedStatus, isLoadingListClassifiedStatus: false }
        case EDIT_CLASSIFIED_STATUS:
            var editClassifiedStatus = state.listClassifiedStatus
            editClassifiedStatus[action.payload.index] = action.payload.data
            return { ...state, listClassifiedStatus: editClassifiedStatus, isLoadingListClassifiedStatus: false }
        case IS_LOADING_GET_LIST_CLASSIFIED_STATUS:
            return { ...state, isLoadingListClassifiedStatus: true }
        case GET_LIST_CLASSIFIED_STATUS:
            return { ...state, listClassifiedStatus: action.payload, isLoadingListClassifiedStatus: false }
        case DELETE_CLASSIFIED_STATUS:
            var deleteClassifiedStatus = state.listClassifiedStatus
            deleteClassifiedStatus.splice(action.payload, 1)
            return { ...state, isLoadingListClassifiedStatus: false, listClassifiedStatus: deleteClassifiedStatus }
        case GET_CLASSIFIED_STATUS:
            return { ...state, classifiedStatus: action.payload }




        case IS_LOADING_GET_LIST_CHAT_CATEGORIES:
            return { ...state, isLoadingListChatCategories: true }
        case GET_LIST_CHAT_CATEGORIES:
            return { ...state, listChatCategories: action.payload, isLoadingListChatCategories: false }
        case DELETE_CHAT_CATEGORY:
            var deleteChatCategorie = Array.from(state.listChatCategories)
            deleteChatCategorie.splice(action.payload, 1)
            return { ...state, isLoadingListChatCategories: false, listChatCategories: deleteChatCategorie }
        case  CREATE_CHAT_CATEGORIE:
            var addChatCategorie = Array.from(state.listChatCategories)
            addChatCategorie.push(action.payload)
            return { ...state, listChatCategories: addChatCategorie, isLoadingListChatCategories: false } 
        case EDIT_CHAT_CATEGORIE:
            var editChatCategory = Array.from(state.listChatCategories)
            editChatCategory[action.payload.index] = action.payload.data
            return { ...state, listChatCategories: editChatCategory, isLoadingListChatCategories: false }
        case GET_CHAT_CATEGORY:
            return { ...state, chatCategoryInfo: action.payload }
        
        
        case IS_LOADING_GET_LIST_COMMUNITY_CATEGORIES:
            return { ...state, isLoadingListCommunityCategories: true }
        case  CREATE_COMMUNITY_CATEGORIE:
            var addCommunityCategory = Array.from(state.listOfCommunitiesCategory)
            addCommunityCategory.push(action.payload)
            return { ...state, listOfCommunitiesCategory: addCommunityCategory, isLoadingListCommunityCategories: false } 
        case EDIT_COMMUNITY_CATEGORIE:
            console.log()
            var editCategoryCommunity = Array.from(state.listOfCommunitiesCategory)
            editCategoryCommunity[action.payload.index] = action.payload.data
            return { ...state, listOfCommunitiesCategory: editCategoryCommunity, isLoadingListCommunityCategories: false }
        case GET_LIST_COMMUNITY_CATEGORIES:
            return { ...state, isLoadingListCommunityCategories: false, listOfCommunitiesCategory: action.payload }
        case GET_COMMUNITY_CATEGORY:
            return { ...state, communityCategoryInfo: action.payload }
        case DELETE_COMMUNITY_CATEGORY:
            var deleteCommunityCategorie = Array.from(state.listOfCommunitiesCategory)
            deleteCommunityCategorie.splice(action.payload, 1)
            return { ...state, isLoadingListCommunityCategories: false, listOfCommunitiesCategory: deleteCommunityCategorie }


        case IS_LOADING_GET_LIST_PROFESSIONAL_COMMUNITY_CATEGORIES:
            return { ...state, isLoadingListProfessionalCommunityCategories: true }
        case  CREATE_PROFESSIONAL_COMMUNITY_CATEGORIE:
            var addProfessionalCommunityCategory = state.listOfProfessionalCommunitiesCategory
            addProfessionalCommunityCategory.push(action.payload)
            return { ...state, listOfProfessionalCommunitiesCategory: addProfessionalCommunityCategory, isLoadingListProfessionalCommunityCategories: false } 
        case EDIT_PROFESSIONAL_COMMUNITY_CATEGORIE:
            console.log()
            var editCategoryCommunity = state.listOfProfessionalCommunitiesCategory
            editCategoryCommunity[action.payload.index] = action.payload.data
            return { ...state, listOfProfessionalCommunitiesCategory: editCategoryCommunity, isLoadingListProfessionalCommunityCategories: false }
        case GET_LIST_PROFESSIONAL_COMMUNITY_CATEGORIES:
            return { ...state, isLoadingListProfessionalCommunityCategories: false, listOfProfessionalCommunitiesCategory: action.payload }
        case GET_PROFESSIONAL_COMMUNITY_CATEGORY:
            return { ...state, communityCategoryInfo: action.payload }
        case DELETE_PROFESSIONAL_COMMUNITY_CATEGORY:
            var deleteCommunityCategorie = state.listOfProfessionalCommunitiesCategory
            deleteCommunityCategorie.splice(action.payload, 1)
            return { ...state, isLoadingListProfessionalCommunityCategories: false, listOfProfessionalCommunitiesCategory: deleteCommunityCategorie }
        default:
            return state

    }
}
